import { render, staticRenderFns } from "./speakerCards.vue?vue&type=template&id=a1febd04&"
import script from "./speakerCards.ts?vue&type=script&lang=js&"
export * from "./speakerCards.ts?vue&type=script&lang=js&"
import style0 from "./speakerCards.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports